import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import KnowledgeDocumentsPaginatedGql from '@/extensions/knowledge-base/store/graphql/queries/KnowledgeDocumentsPaginated.gql';

export default {
    fetchKnowledgeDocumentsPaginated: (data, knowledgeSourceId) =>
        new Promise((resolve, reject) => {
            if (!knowledgeSourceId) {
                reject(new Error('knowledge_source_id is required'));
                return;
            }

            const filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: KnowledgeDocumentsPaginatedGql,
                    variables: {
                        knowledge_source_id: parseInt(knowledgeSourceId),
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'title'),
                        direction: _.get(data, 'variables.direction', 'asc'),
                        filters
                    },
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.EX_AI_KnowledgeDocumentsPaginated))
                .catch(err => reject(err));
        })
};
